import { gql } from '@apollo/client';

export const startCharge = gql`
  mutation startCharge($input: StartChargeInput!) {
    startCharge(input: $input)
  }
`;
